export default "__VITE_ASSET__CKIbPW8j__"